<form [formGroup]="form">
  <div class="fields-container">
    <div class="field-control" id="topup_amount">
      <app-text-field
        type="number"
        [label]="'PAYMENT_SRVICE_AMOUNT' | translate"
        [otherInfo]="'PAYMENT_SRVICE_AMOUNT_DESC' | translate : {amount:50000 | currency}"
        [control]="form.get('amount')"
        [validationMessages]="{
          numberOnly: 'VALIDATION_MSG.NUMBER_ONLY' | translate
        }"
        [maxlength]="50000"
      />
    </div>

    <!----- SUBMIT actions --------->
    <div class="buttons-group">
       @if(!formSubmitLoader){
        <app-button
        type="button"
        classesName="btn-edge-cut  btn-width-auto"
        [label]="'RECHARGE' | translate"
        (onBtnClick)="submitRequest()"
      />
       }
      @if(formSubmitLoader){
          <app-button
            type="button"
            classesName="btn-edge-cut btn-width-auto"
            [label]="'PLEASE_WAIT' | translate"
            [disabled]="true"
          ></app-button>
          }
      <!-- <app-button
        type="button"
        classesName="card-edge-cut-white btn-width-auto"
        [label]="'BUTTONS.SAVE_CLOSE' | translate"
        (onBtnClick)="close()"
      /> -->
    </div>
  </div>
</form>
